import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconComponent } from '../../../icon/icon.component';
import { LinkComponent } from '../../../link/link.component';
import { ButtonComponent } from '../../../button/button.component';
import { SanitizeUrlPipe } from '../../pipes/sanitize-url.pipe';

@Component({
    selector: 'nw-contact-us-block',
    imports: [IconComponent, LinkComponent, ButtonComponent, SanitizeUrlPipe],
    templateUrl: './contact-us-block.component.html',
    styleUrl: './contact-us-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsBlockComponent {
    @Input() telephonenumber!: string;
    @Input() adviceemailaddress!: string;
    @Input() clientserviceemailaddress!: string;
    @Input() scheduletimelink!: string;
    @Input() maplink!: string;
    @Input() mapembed!: string;
}
